import { render, staticRenderFns } from "./Vimeo.vue?vue&type=template&id=60a34ba8"
import script from "./Vimeo.vue?vue&type=script&lang=js"
export * from "./Vimeo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports